module.exports = __webpack_public_path__ + "img/s1-title.a3fd8b8c.png";